import { anatomyToVector } from "./index6.js";
import { MathUtils, Vector3 } from "three";
var a = new Vector3();
var b = new Vector3();
const isJointRightAngled = (joint) => {
	if (joint.bones.length !== 2) return false;
	const bone0 = anatomyToVector(joint.bones[0], a);
	const bone1 = anatomyToVector(joint.bones[1], b);
	return bone0.angleTo(bone1) * MathUtils.RAD2DEG === 90;
};
export { isJointRightAngled };

//# sourceMappingURL=index227.js.map